import { PropsWithChildren } from 'react';

import { colors } from '@/colors';
import { Container } from '@/components/Container';
import { RoundBorderContainer } from '@/components/RoundBorderContainer';

const ROUND_BUTTON_SIZE = 32;

export const AddNewButtonShell = ({
  children,
  onClick,
  hideAddIcon = false,
}: PropsWithChildren & { onClick: () => void; hideAddIcon?: boolean }) => {
  return (
    <RoundBorderContainer
      sx={{
        borderRadius: '10px',
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        alignItems: 'center',
        backgroundColor: colors.grayLightest,
      }}
      onClick={onClick}
    >
      <Container sx={{ flex: 1, textAlign: 'left', padding: '8px 16px' }}>{children}</Container>
      {!hideAddIcon && (
        <Container
          sx={{
            flex: 0,
            flexBasis: '20px',
            backgroundColor: 'black',
            color: 'white',
            borderRadius: ROUND_BUTTON_SIZE,
            width: ROUND_BUTTON_SIZE,
            height: ROUND_BUTTON_SIZE,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '8px 16px',
          }}
        >
          <img src={'/icons/plus_icon.svg'} width={ROUND_BUTTON_SIZE} height={ROUND_BUTTON_SIZE} />
        </Container>
      )}
    </RoundBorderContainer>
  );
};
